import { Dossier } from '@models/dossier/dossier';
import { UserItem } from 'app/core/services/api-client';
import { Role } from 'app/modules/shared-area/ducks/user/models/role';

export interface ISearchState {
  search: string;
  hits: Set<string>;
  currentHit: string | null;
  isWholeWord: boolean;
  isIgnoreCase: boolean;
  state: SearchState;
}

export interface IDossierState {
  id?: string;
  erfassungId?: number;
  isLoading: boolean;
  dossier: Dossier;
  isDeleting: boolean;
  isDeleted: boolean;
  roleContext?: Role;
  isReEditing?: boolean;
  isTaking: boolean;
  isPartialUpdateInProgress: boolean;
  renderState: Map<string, RenderState>;
  renderingItems: number;
  searchState: ISearchState;
  submitIsBusy: boolean;
  copySachverhalte: {
    dossierIds: number[];
    isLoading: boolean;
  };
  sachverhaltToggle: {
    isVisible: boolean;
    mode: 'feedback' | 'copy' | null;
    selectedSachverhalte: Array<{
      sachverhaltId: number;
      erfassungSachverhaltId: number;
      merkmalName: string;
      merkmalId: number;
    }>;
  };
  thesaurusMode?: ThesaurusMode;
  assignableUsers: {
    isLoading: boolean;
    users: UserItem[];
    error: string | null;
  };
}

export type RenderState = 'rendering' | 'rendered';
export type SearchState = 'unknown' | 'searching' | 'searched';
export type ThesaurusMode = 'none' | 'original' | 'recalculated';

export const initialDossierState: IDossierState = {
  id: null,
  erfassungId: null,
  isLoading: false,
  dossier: null,
  isDeleting: false,
  isDeleted: false,
  roleContext: null,
  isReEditing: false,
  isTaking: false,
  renderState: new Map(),
  renderingItems: 0,
  isPartialUpdateInProgress: false,
  searchState: {
    search: '',
    hits: new Set<string>(),
    currentHit: null,
    isIgnoreCase: true,
    isWholeWord: false,
    state: 'unknown',
  },
  submitIsBusy: false,
  copySachverhalte: {
    dossierIds: [],
    isLoading: false,
  },
  sachverhaltToggle: {
    isVisible: false,
    mode: null,
    selectedSachverhalte: [],
  },
  thesaurusMode: 'none',
  assignableUsers: {
    isLoading: false,
    users: [],
    error: null,
  },
};
